export default function ({ $auth, redirect }) {
  const roles = $auth?.user?.data?.roles || []
  const isAdmin = roles.includes('admin') || roles.includes('superAdmin')

  if (!isAdmin) {
    return redirect('/')
  }
}
